export type NotificationType = 'Document' | 'Other';

export const notificationType: Record<NotificationType, NotificationType> = {
  Document: 'Document',
  Other: 'Other',
};
